module.exports = __webpack_public_path__ + "img/f2-4.d6310ad3.jpg";